export default class RowsPerPageOptions {
    static items = [1, 5, 10, 20, 50, 100];

    static defaultPageSize = RowsPerPageOptions.items[2];
}
